// extracted by mini-css-extract-plugin
export default {"main":"_6abc64d384 a35ac93850","xmark":"_4b2b2def57","fl_img":"_4d6c8d085a c6e5d4d5e6"};